'use strict';

import {validate} from './validator.js';
import XMLParser from './xmlparser/XMLParser.js';
import XMLBuilder from './xmlbuilder/json2xml.js';

const XMLValidator = {
  validate: validate
}
export {
  XMLParser,
  XMLValidator,
  XMLBuilder
};